import { z } from 'zod';

export type ExploreRow = z.infer<typeof exploreRowSchema>;

export const exploreRowSchema = z.object({
  data: z.array(z.number()),
  playerId: z.uuid(),
  playerName: z.string(),
  playerNumber: z.string().nullable(),
});
